import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const WaterTaxiIcon: FC<IconProps> = ({ width = 100, height = 30, ...rest }) => (
  <Icon type="WaterTaxi" width={width} height={height} alt="iconWaterTaxi" ignoreRtl {...rest} />
)
